import { render, staticRenderFns } from "./registry.component.html?vue&type=template&id=06464e1f&scoped=true&external"
import script from "./registry.component.ts?vue&type=script&lang=ts&external"
export * from "./registry.component.ts?vue&type=script&lang=ts&external"
import style0 from "./registry.component.scss?vue&type=style&index=0&id=06464e1f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06464e1f",
  null
  
)

export default component.exports